
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import AwardTemplateForm from "./AwardTemplateForm";

function AwardMainForm() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <AwardTemplateForm/>
            </BasicCard>
        </>
    )
}
export default AwardMainForm;